import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable()
export class ApplicationService {

    getEventRoute = '/api/user/';

    constructor(private dataService: DataService) {
    };

    getDebitDays(refresh: boolean) {
        return this.dataService.getData('/api/lookup/debitDaysType', refresh);
    }

    getServiceChange(refresh: any) {
        return this.dataService.getData('/api/application/getServiceChangeDetails', refresh);
    }
    save(applicationViewModel: any) {
        return this.dataService.post('/api/application/saveapplication', applicationViewModel).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    saveRenewVoucher(renewVoucherViewModel: any) {
        return this.dataService.post('/api/application/saveRenewVoucher', renewVoucherViewModel).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    updateStatus(data) {
        return this.dataService.post('/api/application/updateStatus', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    renewPaymentLink(renewPayLinkViewModel: any) {
        return this.dataService.post('/api/application/renewPaymentLink', renewPayLinkViewModel).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    checkRecurrigProduct(productId) {
        return this.dataService.getRecord('/api/application/checkrecurringprodurct/' + productId);
    }

    getApplicationList(refresh: boolean) {
        return this.dataService.getData('/api/application/getdashboardapplicationlist', refresh);
    }

    getfailreasons(id) {
        return this.dataService.getRecord('/api/application/getfailreasons/' + id);
    }
    getWifiDetails(value) {
        return this.dataService.getRecord('/api/application/getWifiDetails/' + value);
    }

    getManageOrderList(refresh: boolean, pagination?: any) {
        return this.dataService.getRecordWithParams('/api/user/manageOrder', pagination);
    }

    changeStatusForZoom(result) {
        return this.dataService.post('/api/application/changeStatusForZoom', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getIpAddress(refresh: boolean) {
        return this.dataService.getData('/api/application/getipaddress', refresh);
    }

    getProductById(productId) {
        return this.dataService.getRecord('/api/application/getproductbyid/' + productId);
    }

    postRenewalOrder(result: any) {
        return this.dataService.post('/api/application/applicationrenewval', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getWifiCredentialWithReference(reference) {
        return this.dataService.getRecord('/api/application/getWifiCredentialWithReference/' + reference);
    }

    updateWifiCredentialWithReference(applicationViewModel: any) {
        return this.dataService.post('/api/application/updateWifiCredentialWithReference', applicationViewModel).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getCustomerInfoForCancellation(reference) {
        return this.dataService.getRecord('/api/application/getCustomerInfoForCancellation/' + reference);
    }

    getCustomerInfoForServiceChange(reference) {
        return this.dataService.getRecord('/api/application/getCustomerInfoForServiceChange/' + reference);
    }

    saveCustomerCancellation(cancellationViewModel: any) {
        return this.dataService.post('/api/application/saveCustomerCancellation', cancellationViewModel).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    zoomNetworkSave(data: any) {
        return this.dataService.post('/api/application/zoomNetworkSave', data).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getPaymentHistoryWithReference(reference) {
        return this.dataService.getRecord('/api/application/getPaymentHistoryWithReference/' + reference);
    }
    saveServiceChange(result: any) {
        return this.dataService.post('/api/application/saveServiceChange', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getusermailstatus(result) {
        return this.dataService.post('/api/application/getusermailstatus/', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    saveCustomerChangeOfService(cancellationViewModel: any) {
        return this.dataService.post('/api/application/saveCustomerChangeOfService', cancellationViewModel).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    applyEFTFilter(search) {
        return this.dataService.getRecord('/api/user/getEFTbysearch/' + search);
    }

    applyFilter(search, pagination?: any) {
        return this.dataService.getRecordWithParams('/api/user/getapplicationbysearch/' + search, pagination);
    }

    applyUserFilter(search) {
        return this.dataService.getRecordWithParams('/api/application/getManageUserBySearch', search);
    }

    getChartApplicationStatus(monthType, refresh: boolean) {
        return this.dataService.getData('/api/application/getchartapplicationstatus/' + monthType, refresh);
    }

    getChartVSApplicationStatus(monthType, refresh: boolean) {
        return this.dataService.getData('/api/application/getchartVSapplicationstatus/' + monthType, refresh);
    }

    getApplicationListByUserId(userId, refresh) {
        return this.dataService.getRecord('/api/application/getapplicationbyuserid/' + userId);
    }
    getApplicationListByApplicationId(appId) {
        return this.dataService.getRecord('/api/application/GetApplicationByApplicationid/' + appId);

    }

    getRenewVoucherList(refresh: boolean) {
        return this.dataService.getRecord('/api/lookup/renewVoucherType');
    }

    getApplicationGetTypeList(refresh: boolean) {
        return this.dataService.getRecord('/api/lookup/applicationGetType');
    }

    getrecurringapplicationbyuserid(refresh: boolean) {
        return this.dataService.getData('/api/application/getrecurringapplicationbyuserid', refresh);
    }
    postRetryPayment(result: any) {
        return this.dataService.post('/api/application/postretrypayment', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    updateCreditCard(result: any) {
        return this.dataService.post('/api/application/updatecreditcard', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    getApplicationSubCategory(refresh: boolean) {
        return this.dataService.getData('/api/application/getApplicationSubcategory', refresh);
    }

    getRecurringApplicationforCreditcard(refresh: boolean) {
        return this.dataService.getData('/api/application/getrecurringapplicationforcreditcard', refresh);
    }

    postRetryOrderPendingApplication(result: any) {
        return this.dataService.post('/api/application/retryorderpendingapplication', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    isAllowFriendMenu(refresh: boolean) {
        debugger
        return this.dataService.getData('/api/application/isAllowFriendMenu', refresh);
    }

    // getCustomerReport(refresh: boolean) {
    //     return this.dataService.getData('/api/user/getcustomerreport', refresh);
    // }

    getCustomerReport(result: any) {
        return this.dataService.getRecordWithParams('/api/user/getCustomerReport', result);
    }

    getWebHookByApplicationId(applicationId: number) {
        return this.dataService.getRecord('/api/application/getWebHookByApplicationId/' + applicationId);
    }
    getAppHistoryDetId(applicationId: number) {
        return this.dataService.getRecord('/api/application/getAppHistoryDetailId/' + applicationId);

    }

    getApplicationPayMentDetails(refresh: boolean) {
        return this.dataService.getRecord('/api/application/getApplicationForPayNow');
    }

    getApplicationForResellerPayNow(refresh: boolean) {
        return this.dataService.getRecord('/api/application/getApplicationForResellerPayNow')
    }

    saveEFTDocument(eftDocumentViewModel: any) {
        return this.dataService.post('/api/application/saveEFTDocument', eftDocumentViewModel).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getEFTPayments() {
        return this.dataService.getRecord('/api/application/getEFTPayments');
    }

    getCreditCardPayments() {
        return this.dataService.getRecord('/api/application/getCreditCardPayments');
    }
    goToPageload(applicationid: number) {
        return this.dataService.getRecord('/api/application/goToVALogin/' + applicationid);
    }

    getEFTImageOrDoc(id: number) {
        return this.dataService.getRecord('/api/application/getEFTImageOrDoc/' + id);

    }

    // getCommissiomReport(result:any) {
    //     return this.dataService.getRecordWithParams('/api/user/getCommissionReport', result);
    // }

    getVoucherReport(result: any) {
        return this.dataService.post('/api/user/getVoucherReport', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }


    getCommissionReport(result: any) {
        return this.dataService.post('/api/user/getCommissionReport', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getPaymentReport(result: any) {
        return this.dataService.post('/api/user/getPaymentReport', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getFailedPaymentReport(result) {
        return this.dataService.post('/api/user/getFailedPaymentReport', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getOnceOffExpiryReport(result: any) {
        return this.dataService.post('/api/application/onceOffExpiryReport', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getVematelCancellationType(refresh: boolean) {
        return this.dataService.getData('/api/application/getVumetalTerminationReasons', refresh);
    }
    getPaymentProcess(result: any) {
        return this.dataService.post('/api/application/CreditCardCheckOut', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
    getPaymentResult(result: any) {
        return this.dataService.post('/api/application/getPaymentResult', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getAppDatas(appId) {
        return this.dataService.getRecord('/api/application/getAppDatas/' + appId);
    }
    getUserLogin(refresh: boolean) {
        return this.dataService.getData('/api/application/getUserLoginDetails', refresh);
    }

    searchCommunication(data) {
        return this.dataService.post('/api/application/searchCommunication', data);
    }

    deletetheorder(id, reason, number) {
        return this.dataService.getRecord('/api/application/deletetheorder/' + id + '/' + reason + '/' + number);
    }
    renewvoucher(appid) {
        return this.dataService.getRecord('/api/application/renewvoucher/' + appid);
    }

    getcustomerdetail(entry) {
        return this.dataService.getRecord('/api/application/getcustomerdetail/' + entry);

    }
    paidorunpaidchange(id, actioninfo, appid) {
        return this.dataService.getRecord('/api/application/paidorunpaidchange/' + id + '/' + actioninfo + '/' + appid);
    }
    getzoompaid(ref) {
        return this.dataService.getData('/api/application/getzoompaid', ref);
    }

    getOpenserveVoucherProducts(downloadSpeed) {
        return this.dataService.getRecord('/api/application/getOpenserveVoucherProducts/' + downloadSpeed);
    }

    openServeInflightCancellation(data) {
        return this.dataService.post('/api/application/inflightCancellation', data);
    }

    getOrderListByFilterSearch(payload) {
        return this.dataService.getRecordWithParams('/api/application/getOrdersByFilterSearch', payload);
    }
    // deleteUser(userId) {
    //     return this.dataService.getRecord('/api/user/deleteUser/' + userId);
    // }

    CheckPromotionIsApplicable() {
        return this.dataService.getRecord('/api/application/CheckPromotionIsApplicable');
    }


    getPaymentReminderReport(result: any) {
        return this.dataService.post('/api/user/getPaymentReminderReport', result).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }

    getManageOrdersByFilterExport(payload: any) {
        return this.dataService.getRecordWithParams('/api/application/getManageOrdersByFilterExport', payload);
    }

    getResellerDashboardDetails() {
        return this.dataService.getRecord('/api/reseller/getResellerDashboardDetails');
    }

    getResellerApplicationDetails(payload: any) {
        return this.dataService.getRecordWithParams('/api/reseller/getResellerApplicationDetails', payload);
    }

    getResellerUserDetails(payload: any) {
        return this.dataService.getRecordWithParams('/api/reseller/getResellerUserDetails', payload);
    }

    getResellerSalesListByResellerCode(code: string) {
        return this.dataService.getRecord('/api/reseller/getResellerSalesListByResellerCode/' + code);
    }
    ZoomPaymentStatusUpdate(appId: any) {
        return this.dataService.getRecord('/api/Zoom/ZoomPaymentSuccess/' + appId);
    }
    ZoomWifiDetails(appId: any) {
        return this.dataService.getRecord('/api/Zoom/ZoomWifiDetails/' + appId);
    }
    getResellerCode() {
        return this.dataService.getRecord('/api/reseller/getResellerCode/');
    }

    getSalesRepCode() {
        return this.dataService.getRecord('/api/reseller/getSalesRepCode');
    }

    onSaveResellerRep(payload: any) {
        return this.dataService.post('/api/application/SaveResellerOrSalesRepByAdmin', payload).map(response => {
            this.dataService.clearRouteCache(this.getEventRoute);
            return response;
        });
    }
}
